
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import StaticPage from '../components/StaticPage';
import Link from 'next/link';
import Section from './layouts/Section';
import {MailingListSubscribe} from '../components/MailingListSubscribe';
import {NextSeo} from 'next-seo';
export const title = 'Open Positions';

const layoutProps = {
  title
};
const MDXLayout = ({children}) => (
  <>
    <NextSeo title="Working at Polar Signals" />
    <StaticPage title={title} subTitle={<>Join us at Polar Signals!</>}>
      {children}
    </StaticPage>
  </>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3>{`Hello 👋`}</h3>
    <p>{`We are Polar Signals, a remote first software company founded in 2020. Here you will find out all about how working at Polar Signals is like and what kind of openings we have. Even if we don't have a specific opening, please don't hesitate to contact us: `}<em parentName="p"><a parentName="em" {...{
          "href": "mailto:jobs@polarsignals.com"
        }}>{`jobs@polarsignals.com`}</a></em>{`.`}</p>
    <h3>{`Mission 🚀`}</h3>
    <p>{`Our mission is to make understanding code accessible to every engineer.`}</p>
    <h3>{`Core values ⚖️`}</h3>
    <ul>
      <li parentName="ul">{`Creative and employee centric work environment`}</li>
      <li parentName="ul">{`Inclusive over exclusive`}</li>
      <li parentName="ul">{`Trust, not control`}</li>
      <li parentName="ul">{`Open information, open decision making`}</li>
      <li parentName="ul">{`Automation over process`}</li>
    </ul>
    <h3>{`Benefits 💎`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Salaries`}</strong>{` - Open global salary and generous early-employee equity package.`}</li>
      <li parentName="ul"><strong parentName="li">{`Remote`}</strong>{` - Free to work from anywhere. We have a strong design-document culture "When in doubt, write it out".`}</li>
      <li parentName="ul"><strong parentName="li">{`Flexible work schedule`}</strong>{` - You decide how and when to structure your workday.`}</li>
      <li parentName="ul"><strong parentName="li">{`20% time`}</strong>{` - Every Friday you are free to do whatever you want. You can choose to make it a 3 day weekend, or hack on that side project you've been wanting to do.`}</li>
      <li parentName="ul"><strong parentName="li">{`5 weeks of PTO`}</strong>{` - We want employees to be well-rested.`}</li>
      <li parentName="ul"><strong parentName="li">{`Unlimited sick leave`}</strong>{` - You're sick when you're sick, not on a schedule.`}</li>
      <li parentName="ul"><strong parentName="li">{`Menstrual leave`}</strong>{` - We support menstrual leave, when you're in pain, rest, don't work.`}</li>
      <li parentName="ul"><strong parentName="li">{`Parental leave`}</strong>{` - We want parent(s) to focus on their child and themselves.`}</li>
      <li parentName="ul"><strong parentName="li">{`Open Source`}</strong>{` - We are passionate about open-source and encourage you to contribute on company time.`}</li>
      <li parentName="ul"><strong parentName="li">{`1 Day a week company meetings`}</strong>{` - All other days are entirely meeting-free.`}</li>
      <li parentName="ul"><strong parentName="li">{`2 Company off-sites per year`}</strong>{` - All-company get-togethers twice a year for work and fun. Previous destinations include Lisbon and Valencia.`}</li>
      <li parentName="ul"><strong parentName="li">{`Conferences`}</strong>{` - Budget to attend conferences, and attend any conference that you speak at.`}</li>
      <li parentName="ul"><strong parentName="li">{`Budget`}</strong>{` - Educational, fitness, and well-being budget.`}</li>
    </ul>
    <h3>{`Our tech stack 💻`}</h3>
    <p>{`Backend:`}</p>
    <ul>
      <li parentName="ul">{`Go`}</li>
      <li parentName="ul">{`gRPC`}</li>
      <li parentName="ul">{`Kubernetes/GKE`}</li>
      <li parentName="ul">{`Observability: Parca, Prometheus, Thanos, Jaeger+OpenTelemetry`}</li>
      <li parentName="ul">{`Hashicorp Vault`}</li>
    </ul>
    <p>{`Frontend`}</p>
    <ul>
      <li parentName="ul">{`TypeScript`}</li>
      <li parentName="ul">{`NextJS`}</li>
      <li parentName="ul">{`React`}</li>
      <li parentName="ul">{`Tailwind`}</li>
      <li parentName="ul">{`gRPC-web`}</li>
      <li parentName="ul">{`Vercel`}</li>
    </ul>
    <h3>{`Open positions 🌱`}</h3>
    <p>{`We currently have no open positions, please subscribe below to get notified when new roles are added.`}</p>
    <MailingListSubscribe caption="Sign up for updates on future job openings" actionURL="https://polarsignals.us2.list-manage.com/subscribe/post?u=2f3e518c3a53f2159fa15ea01&amp;id=0cf37f2b48" mediumWidth={true} mdxType="MailingListSubscribe" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;